import asyncComponent from 'utils/asyncComponent'

import Styled from './styled'

const ModalLogin = asyncComponent(() => import('components/Modal/ModalLogin'))
const HeaderServiceFlow = asyncComponent(() => import('components/HeaderServiceFlow'))
const HeaderServiceReservation = asyncComponent(() => import('components/HeaderServiceReservation'))

export default function LayoutService({ children, title, needLogin = false, onBack = () => null }) {
  return (
    <Styled>
      <div className="render-desktop-lg">
        <HeaderServiceFlow />
      </div>
      <div className="render-mobile-lg">
        <HeaderServiceReservation title={title} onBack={onBack} />
      </div>

      {children}

      <ModalLogin needLogin={needLogin} />
    </Styled>
  )
}
